import { cn } from '@/lib/utils';

type Props = {
  source: string;
  minScore: number;
  days: number;
  sourceTypes: string[];
  onChange: (next: { source: string; minScore: number; days: number }) => void;
};

const selectClass = cn(
  'bg-surface-elevated border border-border rounded-(--radius-sm) px-3 py-2 text-sm min-h-11',
  'font-(family-name:--font-body) focus:outline-2 focus:outline-offset-2 focus:outline-accent'
);

const labelClass = cn(
  'text-xs uppercase tracking-widest text-muted font-(family-name:--font-ui)'
);

export function FeedFilters({ source, minScore, days, sourceTypes, onChange }: Props) {
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-3 items-end mt-3">
      <label className="flex flex-col gap-1 min-w-[8rem]">
        <span className={labelClass}>Source</span>
        <select
          className={selectClass}
          value={source}
          data-focus-filter
          onChange={(e) => onChange({ source: e.target.value, minScore, days })}
        >
          <option value="">all</option>
          {sourceTypes.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </label>
      <label className="flex flex-col gap-1 min-w-[7rem]">
        <span className={labelClass}>Min score</span>
        <select
          className={selectClass}
          value={minScore}
          onChange={(e) => onChange({ source, minScore: Number(e.target.value), days })}
        >
          <option value={0}>any</option>
          <option value={4}>≥ 4</option>
          <option value={6}>≥ 6</option>
          <option value={8}>≥ 8</option>
        </select>
      </label>
      <label className="flex flex-col gap-1 min-w-[7rem]">
        <span className={labelClass}>Range</span>
        <select
          className={selectClass}
          value={days}
          onChange={(e) => onChange({ source, minScore, days: Number(e.target.value) })}
        >
          <option value={1}>1 day</option>
          <option value={3}>3 days</option>
          <option value={7}>7 days</option>
          <option value={30}>30 days</option>
        </select>
      </label>
    </div>
  );
}
